import React, {useEffect, useState} from "react";
import TopNavBar from "../../components/TopNavBar";
import SideNavBar from "../../components/SideNavBar";
import {Outlet} from "react-router-dom";
import "./index.css";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {useAddMessageTokenMutation} from "../../redux/services/authService";
import {generateToken} from "../../firebase";

const MainLayout: React.FC = () => {

    const isRestaurantSelected = useSelector((state: RootState) => state.restaurant.isInitialSlectReastaurant);
    const [addMessageToken] = useAddMessageTokenMutation();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    useEffect(() => {
        const fetchAndUploadToken = async () => {
            try {
                const token = await generateToken();
               
                if (token) {
                    await addMessageToken({
                        token,
                        userType: "Admin",
                    }).unwrap();
                } else {
                    console.error("Failed to generate token.");
                }
            } catch (error) {
                console.error("Error generating or uploading token:", error);
            }
        };

        fetchAndUploadToken();
    }, [addMessageToken]);

    return (
        <>
            <TopNavBar/>
            <div>
                <div className="mainlayoutMainStyles">
                    <div className={`mainlayoutSideNavBarStyles ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                        {!isRestaurantSelected && (<div className="main-layout-side-bar-hide"/>)}
                        <SideNavBar onCollapseChange={setIsSidebarCollapsed} />
                    </div>
                    <div className={`mainlayoutOutletStyles ${isSidebarCollapsed ? 'expanded' : ''}`}>
                        <Outlet/>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MainLayout;
